import { AuthorizationScope } from '../AuthorizationScope'

const scope: AuthorizationScope = {
  _id: 'WORKSPACE_ENTERPRISE',
  name: 'Workspace Enterprise',
  type: 'WORKSPACE',
  description: '',
  modules: [],
  actions: ['READ', 'CREATE', 'UPDATE', 'DESTROY'],
}

export default scope
